import React, { useContext, useEffect, useState, useCallback } from 'react';
import classNames from 'lib/classNames';
import styles from 'styles/charge_approval.module.scss'
import Modal  from "./Modal"
import ShopContext from 'context/ShopContext';


const WelcomeModal = ({  }) => {
	const shopContext = useContext(ShopContext);
	const {
		state: {   redirectToChargeApproval },
	} = shopContext;

	const [isModalVisible, setIsModalVisible] = useState(!localStorage.getItem('__welcome_video') )

    const close = () => {
        localStorage.setItem('__welcome_video', 0);
        setIsModalVisible(false)
    }
    return (
		<div  className={classNames('absolute z-50')}>
            <Modal 
                visible={isModalVisible}   
                onClose ={() => close() }  
                style={{minWidth: "900px", minHeight: "485px" }}
                background="bg-white"
                title={<div className={classNames('font-bold flex-center text-2xl')} >Guide For Instantly Increasing Revenue! 🚀👇 </div>}
            >
                {(close, setTitle) => (
                    <div id='monster-upsell-cart' className={classNames('px-4 h-full w-full ')} >
                        <div className={`${classNames(' h-full w-full')} ${styles.navy_color}`}  >
                            <iframe 
                                style={{width: "100%", height:"100%"}} 
                                frameborder="0" 
                                allowfullscreen="1" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                title="Setup Guide for Increasing Revenue" 
                                src="https://www.youtube.com/embed/Tn6CKnyprA4?autoplay=1&amp;cc_load_policy=1&amp;controls=2&amp;hl=en&amp;rel=0&amp;enablejsapi=1&amp">
                            </iframe>
                        </div>
                    </div>
                )}
            </Modal>
		</div>
    )

}

export default WelcomeModal